import React from "react"
import SettingSection from "@/modules/shared/SettingSection"
import { useTranslation } from "react-i18next"
import SettingContentWrapper from "@/modules/shared/SettingContentWrapper"
import BrandingForm from "./components/BrandingForm"
import TrackingConfigForm from "./components/TrackingConfigForm"

interface BrandingSettingsProps {}

const BrandingSettings: React.FC<BrandingSettingsProps> = () => {
  const { t } = useTranslation()

  return (
    <>
      <SettingSection title={t("common.trackingPage")}>
        <SettingContentWrapper className="flex gap-y-2">
          <BrandingForm />
        </SettingContentWrapper>
        <SettingContentWrapper>
          <TrackingConfigForm />
        </SettingContentWrapper>
      </SettingSection>
    </>
  )
}

export default BrandingSettings
